import script from "./AppLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AppLayout.vue?vue&type=script&setup=true&lang=js"

import "./AppLayout.vue?vue&type=style&index=0&id=cb1835b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb1835b6"]])

export default __exports__